// Dynamically load Google's ReCaptcha while submitting forms
// Use like this:
// $.loadCaptcha(form).then(function(){ ... });

export const initCaptcha = async () => { };

export async function execute(action = '') {
	return new Promise((resolve, reject) => {
		grecaptcha.enterprise.ready(async () => {
			const token = await grecaptcha.enterprise.execute(document.recaptchaKey, {action});
			resolve(token)
		});
	});
};

export const loadCaptcha = async form => {
	const token = await execute();
	if(token)
		form.append(`<input type="hidden" name="g-recaptcha-response" value="${token}" />`);
	return token;
}
